import { Banner } from 'src/components/Banner'
import usePcodeMatch from 'src/hooks/usePcodeMatch.hook'
import RenderIf from 'src/components/RenderIf'
import { MiddleDivider, VerticalDivider } from 'src/components/Divider'
import BillLetterFooter from 'src/components/Footer/BillLetterFooter'
import React from 'react'
import { Button } from 'src/components/Button'
import { useFormContext, useWatch } from 'react-hook-form'
import { AllTermsBooleanType, FormObjectType, JoinFormType } from 'src/types/react-hook-form'
import { BillLetterJoinFormPageProps } from 'src/pages/BillLetterJoinFormPage/index'
import { BillLetterFormStyle as S } from 'src/pages/BillLetterJoinFormPage/styled'
import { FormInput, FormInputWrap, FormItem } from 'src/components/Input/styled'
import PaidNoticeText from 'src/components/PaidNoticeText'
import add_banner_01 from 'src/assets/images/billletter/additional_banner_1.png'
import life_banner_03 from 'src/assets/images/billletter/life_banner_3.png'
import add_banner_03 from 'src/assets/images/billletter/additional_banner_3.png'
import life_banner_04 from 'src/assets/images/billletter/life_banner_4.png'
import banner_05 from 'src/assets/images/billletter/banner_5.png'
import handleAutoInputGuard from 'src/service/utils/handleAutoInputGuard'

const BillLetterJoinFormPageView = (props: BillLetterJoinFormPageProps) => {
  const {
    otpCertVerifyComplete,
    otpCertRequest,
    onBillLetterJoin,
    otpCertVerify,
    goToButtonState,
    handleGoToButton,
    dynamicUiData: { NotiContent, ButtonMsgAfter, UIData },
    registerAttributeExcludeAllTerms: termsData,
    registerAttribute,
    count,
  } = props
  const { handleSubmit, register, getValues } = useFormContext<JoinFormType>()
  const { bill_letter_01: addService } = usePcodeMatch()
  const { layoutsVerify } = UIData
  const isTranID = getValues('TranID') !== ''
  const watchAllTerms = useWatch({ name: 'allTerms' })

  const handleOtpCertRequest = handleSubmit(otpCertRequest.submit, otpCertRequest.error)
  const handleJoinSubmit = handleSubmit(onBillLetterJoin.submit, onBillLetterJoin.error)
  const handleSubmitOtpCertVerify = handleSubmit(otpCertVerify.submit, otpCertVerify.error)

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, callbackFn: () => void) =>
    event.key === 'Enter' && callbackFn()

  const EachTermsCheckBox = ({
    tag,
    termsTitle,
    showTermsPopup,
    register_options,
  }: Partial<FormObjectType>) => {
    const watchTerms = useWatch({ name: tag as keyof AllTermsBooleanType })
    return (
      <S.BillJoinTermsItem type="each" key={tag}>
        <S.BillFormCheckboxLabel type="each" $label_active={watchTerms}>
          <S.BillFormCheckbox {...register(tag as keyof AllTermsBooleanType, register_options)} />
          {termsTitle}
        </S.BillFormCheckboxLabel>
        <S.BillJoinTermsOpenDetail onClick={showTermsPopup}>[보기]</S.BillJoinTermsOpenDetail>
      </S.BillJoinTermsItem>
    )
  }

  const bannerList = {
    banner_01: {
      img: addService ? add_banner_01 : '',
      alt: addService
        ? '휴대폰쿠폰지갑 이통사유료서비스 똑똑한 혜택 휴대폰쿠폰지갑 휴대폰 쿠폰지갑 구독하고 모바일 쿠폰 할인 받자! 매일 쏟아지는 할인 상시 할인 쿠폰에 핫딜 이벤트까지 매월 무료 쿠폰이 쏙 100% 증정 이달의 쿠폰은 꼼꼼한 쿠폰 관리 유효기간 알림으로 놓치는 일 없도록 쿠폰 사용까지 단 3초 앱 열고 터치 한번이면 사용 가능'
        : '',
    },
    //사용 가능성 있음 삭제 X
    banner_02: {
      img: '',
      alt: '',
    },
    banner_03: {
      img: addService ? add_banner_03 : life_banner_03,
      alt: addService
        ? '휴대폰쿠폰지갑 모바일쿠폰 상시 할인 멤버십 서비스 휴대폰쿠폰지갑은 상시 할인된 모바일 쿠폰과 다양한 혜택을 제공하여 알뜰 쇼핑을 도와주는 생활밀착형 제테크 서비스입니다 이용요금 부가세 포함 월5천5백원'
        : '휴대폰쿠폰지갑 이통사유료서비스 휴대폰쿠폰지갑 모바일 쿠폰 할인 서비스 서비스안내 높은 할인율의 모바일 쿠폰 상시 구매 혜택 제공 이용요금 매월 5천5백원 VAT포함 이동통신 요금에 포함 주 데이터유니버스 고객센터 18554531  서비스홈페이지www점couponwallet점co점kr',
    },
    banner_04: {
      img: addService ? undefined : life_banner_04,
      alt: addService
        ? undefined
        : '똑똑한 혜택 휴대폰쿠폰지갑 휴대폰쿠폰지갑 구독하고 모바일 쿠폰 할인 받자 매일 쏟아지는 할인 상시 할인 쿠폰에 핫딜 이벤트까지 매월 무료 쿠폰이 쏙 100 증정 이달의 쿠폰은 꼼꼼한 쿠폰 관리 유효기간 알림으로 놓치는 일 없도록 쿠폰 사용까지 단 3초 앱 열고 터치 한번이면 사용 가능\n',
    },
    banner_05: {
      img: banner_05,
      alt: '여태 정가 주고 샀다고 간식비 아끼는꿀팁 휴대폰 인증 후 간편가입 휴대폰쿠폰지갑으로 할인 받으면 됨\n',
    },
  }

  return (
    <S.BillLetterFormContainer>
      {/*배너*/}
      <RenderIf when={!!bannerList.banner_01.img}>
        <Banner.Items {...bannerList.banner_01} id="banner_01" />
      </RenderIf>
      <RenderIf when={!!bannerList.banner_02.img}>
        <Banner.Items {...bannerList.banner_02} id="banner_02" />
      </RenderIf>
      <RenderIf when={!!bannerList.banner_03.img}>
        <Banner.Items {...bannerList.banner_03} id="banner_03" />
      </RenderIf>
      <MiddleDivider maxWidth="720px" />
      <S.CertFormContainer>
        <S.CertFormContents>
          {/*휴대폰번호 Input*/}
          <FormInput
            {...register('PNumber', registerAttribute.PNumber.register_options)}
            placeholder={'휴대폰 번호를 입력하세요.'}
            type={registerAttribute.PNumber.type}
            inputMode={registerAttribute.PNumber.register_options?.inputMode}
            onChange={registerAttribute.PNumber.register_options?.onChange}
            onKeyDown={(event) => handleKeyDown(event, handleOtpCertRequest)}
            $style={S.BillInputStyle}
            disabled={isTranID}
          />
          {/*인증번호 발송 Button*/}
          <RenderIf when={!isTranID}>
            <Button.OtpCertRequest
              onClick={handleOtpCertRequest}
              $style={S.OtpRequestButton}
              name="인증"
            />
          </RenderIf>
          {/*재전송 버튼*/}
          <RenderIf when={isTranID}>
            <Button.Secondary onClick={handleOtpCertRequest} $style={S.RetryRequestButton}>
              재전송
            </Button.Secondary>
          </RenderIf>
        </S.CertFormContents>
        <RenderIf when={isTranID}>
          <S.OtpFormContainer>
            <FormItem>
              <FormInputWrap>
                {/*인증번호 Input*/}
                <FormInput
                  {...register('ApprovalNumber', registerAttribute.ApprovalNumber.register_options)}
                  placeholder={'인증번호를 입력하세요.'}
                  autoComplete={'one-time-code'}
                  inputMode={registerAttribute.ApprovalNumber.register_options?.inputMode}
                  onChange={registerAttribute.ApprovalNumber.register_options?.onChange}
                  onKeyDown={(event) => handleAutoInputGuard(event, handleSubmitOtpCertVerify)}
                  $style={S.BillInputStyle}
                  disabled={otpCertVerifyComplete}
                />
                <RenderIf when={!otpCertVerifyComplete}>
                  {/*타이머*/}
                  <S.Timer>{count?.substring(4, 12)}</S.Timer>
                  {/*인증번호 검증 버튼*/}
                  <Button.Secondary
                    onClick={handleSubmitOtpCertVerify}
                    $style={S.OtpVerifyButton()}
                  >
                    확인
                  </Button.Secondary>
                </RenderIf>
                {/*인증완료 Button*/}
                <RenderIf when={otpCertVerifyComplete}>
                  <Button.Secondary $style={S.OtpVerifyButton()} disabled={true}>
                    인증완료
                  </Button.Secondary>
                </RenderIf>
              </FormInputWrap>
            </FormItem>
          </S.OtpFormContainer>
        </RenderIf>
        {/*약관 동의 체크박스*/}
        <S.BillJoinTermsWrap>
          <S.BillJoinTermsItem type="all">
            <S.BillFormCheckboxLabel type="all" $label_active={watchAllTerms}>
              <S.BillFormCheckbox
                {...register('allTerms', registerAttribute.allTerms?.register_options)}
                onClick={registerAttribute.allTerms?.register_options?.onClick}
              />
              모두동의
            </S.BillFormCheckboxLabel>
          </S.BillJoinTermsItem>
          <VerticalDivider />
          <S.BillEachTermsContainer>
            {termsData?.map((termsItems) => (
              <EachTermsCheckBox {...termsItems} key={termsItems.tag} />
            ))}
          </S.BillEachTermsContainer>
        </S.BillJoinTermsWrap>
        {/*가입 Button*/}
        <Button.JoinSubmit
          onClick={handleJoinSubmit}
          $style={S.JoinSubmitButton({ ...layoutsVerify?.verifyBtn })}
          disabled={(getValues('TranID') as string) === '' || !otpCertVerifyComplete}
          name={ButtonMsgAfter}
        />
        {/*유료고지문구*/}
        <PaidNoticeText
          NotiContent={NotiContent}
          notiCashSpace={layoutsVerify?.cashSpace}
          $style={S.PaidNotiText}
        />
      </S.CertFormContainer>
      {/*<MiddleDivider maxWidth="720px" />*/}
      <RenderIf when={!!bannerList.banner_04.img}>
        <Banner.Items {...bannerList.banner_04} id="banner_04" />
      </RenderIf>
      <RenderIf when={!!bannerList.banner_05.img}>
        <Banner.Items {...bannerList.banner_05} id="banner_05" />
      </RenderIf>
      <MiddleDivider maxWidth="720px" />
      {/*푸터*/}
      <BillLetterFooter />
      {/*가입 Float Button*/}
      <Button.JoinSubmitFloat
        onClick={handleGoToButton}
        $style={S.JoinSubmitFixedButton(goToButtonState)}
        name={addService ? '바로가기' : ButtonMsgAfter}
      />
    </S.BillLetterFormContainer>
  )
}

export default BillLetterJoinFormPageView
